import React from 'react';

const CreditCardGold = props => {
  return (
    <svg
      width="32"
      height="24"
      viewBox="0 0 32 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1 6H31"
        stroke="#FCB200"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="square"
      />
      <path
        d="M1 11H31"
        stroke="#FCB200"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="square"
      />
      <path
        d="M5 17H12"
        stroke="#FCB200"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="square"
      />
      <path
        d="M25 17H27"
        stroke="#FCB200"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="square"
      />
      <path
        d="M1 21V3C1 1.895 1.895 1 3 1H29C30.105 1 31 1.895 31 3V21C31 22.105 30.105 23 29 23H3C1.895 23 1 22.105 1 21Z"
        stroke="#FCB200"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="square"
      />
    </svg>
  );
};

export default CreditCardGold;



// WEBPACK FOOTER //
// ./src/svg/CreditCardGold.js